<app-common-dialog-wrapper
  headerText="Respond to Product Carbon Footprint Questionnaires in Bulk"
  [confirmButton]="confirmButton"
  [cancelButton]="cancelButton"
  (onDialogClose)="onDialogAction($event)"
  >
  @if (!isTemplateUploaded) {
    <section
      class="bulk-uploader-body"
      >
      <p>
        You may respond to your pending Product Carbon Footprint Questionnaires in
        bulk by:
      </p>
      <div>
        <ol>
          <li>
            <div class="li-content">
              <span class="li-content__label"
                >Download a template with a reference to all your open
                questionnaires.</span
                >
                <mds-button
                  (click)="downloadTemplate()"
                  ariaLabel="Download Excel Template"
                  type="secondary"
                  >
                  Download Excel
                </mds-button>
              </div>
            </li>
            <li>
              <span class="li-content__label">
                Fill out the template with
                <strong>“Carbon Footprint (kg CO2 eq)”</strong> and
                <strong>“Standard”</strong> values.
              </span>
            </li>
            <li>
              <div class="li-content">
                <span class="li-content__label"> Upload your responses. </span>
                <span>
                  <input
                    type="file"
                    #fileInput
                    style="display: none"
                    (change)="onFileSelected($event)"
                    accept="*"
                    />
                  <mds-button
                    ariaLabel="Upload Excel"
                    type="secondary"
                    (click)="triggerFileInput()"
                    >
                    Upload Excel
                  </mds-button>
                </span>
              </div>
              @if (fileToUpload) {
                <span>
                  <mds-chip
                    [label]="fileToUpload.name"
                    [removable]="true"
                    [size]="'medium'"
                    [showChipIcon]="false"
                    [theme]="'light'"
                    [isClickable]="true"
                    [disabled]="false"
                    (onChipRemoved)="removeFile()"
                  ></mds-chip>
                </span>
              }
            </li>
          </ol>
        </div>
      </section>
    } @else {
      <section class="bulk-uploader-body file-uploaded-msg">
        <h2>Thanks for submitting your responses.</h2>
        <p>
          You will receive an email with the status after all your responses have
          been processed. Please reload this page to see the most up to date
          questionnaire status after that.
        </p>
      </section>
    }
  </app-common-dialog-wrapper>

